import { useEffect } from 'react'

const usePageTitle = (title, isPageWindow = false) => {
  useEffect(() => {
    if (!isPageWindow) {
      document.title = title
    }

    return () => {
      document.title = ''
    }
  }, [title, isPageWindow])
}

export { usePageTitle }
